module.exports = "<div *ngIf=\"alert\" class=\"alert alert-{{ alert.type }}\" role=\"alert\" [innerHTML]=\"messageAlerte\"></div>\n"